import React from 'react';
import type { OrganizationAppWithLayout as ServicedeskOrganizationV2Type } from '@atlassian/jira-spa-apps-servicedesk-organization-v2/src/ui/index.tsx';
import { markAsProductBundleReady } from '@atlassian/jira-spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

export const LazyServicedeskOrganizationV2 = lazyForPaint<typeof ServicedeskOrganizationV2Type>(
	() =>
		markAsProductBundleReady(
			import(
				/* webpackChunkName: "async-servicedesk-organization-v2", jiraSpaEntry: "async-servicedesk-organization-v2" */ '@atlassian/jira-spa-apps-servicedesk-organization-v2'
			),
		),
);

export const ServiceDeskOrganizationV2 = (): React.JSX.Element => (
	<LazyPage
		Page={LazyServicedeskOrganizationV2}
		pageId="spa-apps/servicedesk/organization-v2"
		shouldShowSpinner
	/>
);
